import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core'
import { AuthService } from 'src/app/services/auth.service'
import { Router } from '@angular/router'
import { TranslationService } from '../../services/translation.service'
import { WindowRef } from '../../providers/WindowRef'
@Component({
  selector: 'error',
  standalone: true,
  imports: [],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ErrorComponent implements OnInit {
  title: any = ''
  translationCode: any
  constructor(
    private authService: AuthService,
    private winRef: WindowRef,
    private router: Router,
    private translationService: TranslationService
  ) {}
  ngOnInit() {
    this.translationCode =
      this.translationService.getTranslationForPage('error')
    this.title = this.authService.loggedInStatus
      ? this.translationCode['error.goToHome']
      : this.translationCode['error.login']
  }
  navigateToPage() {
    if (this.title == 'Login') {
      this.router.navigateByUrl('../login')
    } else this.router.navigateByUrl('../home')
  }
}
